import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

// 分页查询数据收集模板列表
export const reqDataCollectTemplateList = params => { return axios({method:'post',url:`${base}/datacollect/templatelist`,params:params}).then(res=>res.data); }

// 新增/编辑数据收集模板
export const reqDataCollectTemplateEdit = params => { return axios({method:'post',url:`${base}/datacollect/templateedit`,params:params}).then(res=>res.data); }

// 为隐私信息收集模板批量给多个用户创建待填写数据行
export const reqDataCollectBatchCreateData = params => { return axios({method:'post',url:`${base}/datacollect/batchcreatedata`,params:params}).then(res=>res.data); }

// 导出已提交数据收集为 Excel（按当前查询条件导出全部）
export const reqDataCollectExport = params => { return axios({method:'post',url:`${base}/datacollect/export`,params:params}).then(res=>res.data); }

// 删除数据收集模板
export const reqDataCollectTemplateDelete = params => { return axios({method:'post',url:`${base}/datacollect/templatedelete`,params:params}).then(res=>res.data); }

// 获取某模板的所有字段
export const reqDataCollectFieldList = params => { return axios({method:'post',url:`${base}/datacollect/fieldlist`,params:params}).then(res=>res.data); }

// 新增/编辑字段
export const reqDataCollectFieldEdit = params => { return axios({method:'post',url:`${base}/datacollect/fieldedit`,params:params}).then(res=>res.data); }

// 删除字段
export const reqDataCollectFieldDelete = params => { return axios({method:'post',url:`${base}/datacollect/fielddelete`,params:params}).then(res=>res.data); }

// 批量更新字段排序
export const reqDataCollectFieldSort = params => { return axios({method:'post',url:`${base}/datacollect/fieldsort`,params:params}).then(res=>res.data); }

// 获取所有模板及其字段（用于填写页面）
export const reqDataCollectGetTemplateAll = params => { return axios({method:'post',url:`${base}/datacollect/gettemplateall`,params:params}).then(res=>res.data); }

// 保存数据收集数据（多行文本含回车需放到请求体，避免 URL 传参截断导致保存空白）
export const reqDataCollectSaveData = params => {
  const fd = new URLSearchParams();
  Object.keys(params).forEach(k => fd.append(k, params[k]));
  return axios({method:'post',url:`${base}/datacollect/savedata`,data:fd}).then(res=>res.data);
}

// 分页查询数据收集数据列表
export const reqDataCollectDataList = params => { return axios({method:'post',url:`${base}/datacollect/datalist`,params:params}).then(res=>res.data); }

// 删除数据收集数据
export const reqDataCollectDataDelete = params => { return axios({method:'post',url:`${base}/datacollect/datadelete`,params:params}).then(res=>res.data); }

// 更新数据收集数据（多行文本含回车需放到请求体，避免 URL 传参截断导致保存空白）
export const reqDataCollectUpdateData = params => {
  const fd = new URLSearchParams();
  Object.keys(params).forEach(k => fd.append(k, params[k]));
  return axios({method:'post',url:`${base}/datacollect/updatedata`,data:fd}).then(res=>res.data);
}

// 发送数据收集语音提醒
export const reqDataCollectSendVoiceNotify = params => { return axios({method:'post',url:`${base}/datacollect/sendvoicenotify`,params:params}).then(res=>res.data); }

// 获取模板的可编辑人员列表
export const reqDataCollectGetEditableUsers = params => { return axios({method:'post',url:`${base}/datacollect/geteditableusers`,params:params}).then(res=>res.data); }

// 获取当前用户待完善的数据收集列表
export const reqDataCollectGetPendingData = params => { return axios({method:'post',url:`${base}/datacollect/getpendingdata`,params:params}).then(res=>res.data); }
export const reqDataCollectStat = params => { return axios({method:'post',url:`${base}/datacollect/stat`,params:params}).then(res=>res.data); }

// 执行字段配置的 SQL 获取“数据库来源的下拉选择”选项
export const reqDataCollectExecSql = params => { return axios({method:'post',url:`${base}/datacollect/execsql`,params:params}).then(res=>res.data); }
